import { render, staticRenderFns } from "./WalletsRoles.vue?vue&type=template&id=e0d66f42&"
import script from "./WalletsRoles.vue?vue&type=script&lang=ts&"
export * from "./WalletsRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports